import React from "react";
import { customerNameById, formatKennitala, getPersonTypeByAge } from '../../utils'
import { InsuranceTakerModal } from '../modals'
import connectWithStore from "../../utils/store";
import { setInfoKey } from '../../api/information-collection/actions'
import { fetchCustomer } from '../../api/customers/actions'
import { SvgAddIcon } from '../svg'
import { formatKennitalaAsDate } from '../../utils';
const kennitala = require('kennitala')

import { store } from '../../store'

class InsuranceTaker extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.selectInsuranceTaker = this.selectInsuranceTaker.bind(this)
    }

    getInsuranceTakerName(initialValues, customerId, customers, fieldName){
        let insuranceTakerName = '';
        if (this.isAdult(customers, customerId)) {            
            if (fieldName in initialValues) {
                insuranceTakerName = customerNameById(initialValues[fieldName], customers)
            } else {
                insuranceTakerName = customerNameById(customerId, customers)
            }
        } else if (!this.isAdult(customers, customerId) && fieldName in initialValues){
            insuranceTakerName = customerNameById(initialValues[fieldName], customers)
        }
        return insuranceTakerName;
    }

    isAdult(customers, customerId){
        let cust = customers.customerList.filter(c => c.Customer.AccountNum === customerId)
        let adult = false;

        if (cust[0].type === "adult") {
            adult = true
        }

        return adult
    }

    getCurrentGenderIndex(gender) {
        let genderValue = "0"
        switch (parseInt(gender)) {
            case 0:
                // male
                genderValue = "1"
                break;
            case 1:
                // female
                genderValue = "2"
                break;
            case 2:
                // boy
                genderValue = "1"
                break;
            case 3:
                // girl
                genderValue = "2"
                break;
        }
        return genderValue;
    }


    selectInsuranceTaker(customerId, e) {
        let val = e.target.value;
        let insuranceTaker = this.props.nationalRegistry.history.find(item => item.OrgId === val);
        this.props.dispatch(setInfoKey({key: this.props.fieldName, value: val}, customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Gender", value: this.getCurrentGenderIndex(insuranceTaker.Gender) }, customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Name", value: insuranceTaker.Name }, customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Birthdate", value: formatKennitalaAsDate(val) }, customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Address", value: insuranceTaker.Address }, customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Postcode", value: insuranceTaker.Postcode }, customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "City", value: insuranceTaker.City }, customerId));
        this.props.dispatch(fetchCustomer(val))

        Object.keys(this.props.offers.offerQueryParameters).map((c) => {
            Object.entries(this.props.offers.offerQueryParameters[c]).map(([product, value]) => {
                if (value === true) {
                    let _product = product
                    if (product === 'FOR') {
                        _product = 'REN'
                    }
                    let info = kennitala.info(c)
                    if (info.age <= 17 && this.props.infoCollection.data[c][`${_product}insuranceTaker`] === undefined ) {
                        this.props.dispatch(setInfoKey({key: `${_product}insuranceTaker`, value: val}, c))
                        this.props.dispatch(setInfoKey({ key: `${_product}insuranceTakerGender`, value: this.getCurrentGenderIndex(insuranceTaker.Gender) }, c));
                        this.props.dispatch(setInfoKey({ key: `${_product}insuranceTakerName`, value: insuranceTaker.Name }, c));
                        this.props.dispatch(setInfoKey({ key: `${_product}insuranceTakerBirthdate`, value: formatKennitalaAsDate(val) }, c));
                        this.props.dispatch(setInfoKey({ key: `${_product}insuranceTakerAddress`, value: insuranceTaker.Address }, c));
                        this.props.dispatch(setInfoKey({ key: `${_product}insuranceTakerPostcode`, value: insuranceTaker.Postcode }, c));
                        this.props.dispatch(setInfoKey({ key: `${_product}insuranceTakerCity`, value: insuranceTaker.City }, c));
                
                    }
                }
            })
        })

    }

    render() {
        const { customerId, customers, fieldName, initialValues } = this.props
        let personType = getPersonTypeByAge(customerId)

        return (
            <>
            <div className={`${this.props.errors && this.props.errors.length > 0 ? 'error' : ''} form-row align-items-center`}>
            <div className="col-6">
                <label className="col-12 col-xl d-xl-inline col-form-label pl-0">Tryggingataki: </label>
                {this.props.errors && this.props.errors.length > 0 ?
                    <span className="error"> ({this.props.errors}) </span> : ''
                }
                <span className="col-12 col-xl p-0"></span>
            </div>
            <div className="col-6 text-right">
                { (!this.props.disabled && personType === "child") ?
                    <>
                    {this.props.insuranceTakers && this.props.insuranceTakers.insuranceTakers &&
                        <> {Object.entries(this.props.insuranceTakers.insuranceTakers).length > 0 &&
                            
                            
                            <select name="payers" id="payer-select" onChange={(e) => this.selectInsuranceTaker(customerId, e)} value={initialValues[this.props.fieldName]}>
                                <option value="">Veldu tryggingataka</option>
                                {Object.keys(this.props.insuranceTakers.insuranceTakers).map((p) => 
                                    <option key={p} value={p} >{ this.props.insuranceTakers.insuranceTakers[p].name } ({formatKennitala(this.props.insuranceTakers.insuranceTakers[p].customerId)})</option>
                                )}
                            </select>
                            }
                            <button className="add" onClick={(e) => {e.preventDefault();$("#InsuranceTakerModal-" + this.props.fieldName + "-" + customerId).modal('show')}}><SvgAddIcon /></button>
                        </>
                    }
                    </>
                :
                    <>{this.getInsuranceTakerName(initialValues, customerId, customers, fieldName)}</>
                }
            </div>
        </div>
        <InsuranceTakerModal id={"InsuranceTakerModal-" + fieldName + "-" + customerId} store={this.props.store} customerId={customerId} fieldName={fieldName} isAdult={this.isAdult(customers, customerId)}/>
        </>
        )
    }
}

InsuranceTaker.defaultProps = {
    disabled: false
}

function mapStateToProps(state) {

    var f = {
        infoCollection: {},
        insuranceTakers: {},
        customers: {},
        offers: {},
        nationalRegistry: {},
    }
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry

    return f;
}

export default connectWithStore(store, InsuranceTaker, mapStateToProps);
